<div class="numbers">
  <div class="rank">{{ rank }}.</div>
  <div class="percentage">{{ matchingValue | number: '.1-1':'en' }} %</div>
</div>
<div class="title">{{ title }}</div>
<div class="smartspider">
  <sv-smartspider [smartspiders]="smartspiders"></sv-smartspider>
</div>
